import { MimeType } from '@aline/common';

export const CUSTOM_FILE_TYPES = [
  { label: 'PDF', mimeTypes: [MimeType.PDF] },
  {
    label: 'MS Word',
    mimeTypes: [MimeType.DOC, MimeType.DOCX],
  },
  {
    label: 'MS Excel',
    mimeTypes: [MimeType.XLS, MimeType.XLSX],
  },
  {
    label: 'MS PowerPoint',
    mimeTypes: [MimeType.PPT, MimeType.PPTX],
  },
] as const;

export type FileTypeLabel = (typeof CUSTOM_FILE_TYPES)[number]['label'];

/**
 * Given an array of allowed MIME types, returns human-readable labels.
 * First checks if the set matches a known preset (PDF, Office), then
 * falls back to matching individual CUSTOM_FILE_TYPES groups.
 */
export function getMimeTypeLabels(allowedMimeTypes: string[]): FileTypeLabel[] {
  if (!allowedMimeTypes.length) return [];

  const labels: FileTypeLabel[] = [];
  const mimeSet = new Set(allowedMimeTypes.map(m => m.toLowerCase()));

  for (const ft of CUSTOM_FILE_TYPES) {
    if (ft.mimeTypes.some(m => mimeSet.has(m))) labels.push(ft.label);
  }

  return labels;
}

export function labelsToMimeTypes(labels: FileTypeLabel[]): string[] {
  const mimeTypes = new Set<string>();
  for (const label of labels) {
    const ft = CUSTOM_FILE_TYPES.find(f => f.label === label);
    if (ft) for (const m of ft.mimeTypes) mimeTypes.add(m);
  }
  return [...mimeTypes];
}
